import { CButton, CFormInput, CFormLabel, CFormTextarea } from "@coreui/react";
import { useEffect, useState } from "react";
import AsyncSelect from "react-select/async";
import AxiosInstance from "src/components/Axios";
import { toast } from 'react-toastify'
import { useLoaderData, useNavigate } from "react-router-dom";


const urlApi = '/work_stages_lists'
const urlRouter = '/work_stages_lists'


export async function LoaderPlanStagesUpdate({ params }) {
   console.log('LoadeWorkPlanUpdate params:', params)
   const id = params.pid

   if (Object.keys(params).length !== 0) {
      try {
         const response1 = await AxiosInstance.get(`${urlApi}/${id}`
            // , header
         )
         console.log('response1.data', response1.data)
         return { data: response1.data }
      } catch (error) {
         console.error('Помилка під час виконання запитів', error)
         return null
      }
   }
   return null
}




export default function WorkPlanStagesForm() {
   // хто увійшов
   const role = localStorage.getItem('user_role')
   // console.log(role)
   const { data } = useLoaderData() || []
   console.log('data', data)
   const [userId, setUserId] = useState(false)
   const [dataState, setDataState] = useState(data != undefined ? data : null)



   //для селекта
   const [stageTitle, setStageTitle] = useState('')

   //для нового етапу в інпуті
   const [stageInputText, setStageInputText] = useState(data !== undefined ? data.name : '')
   //для нового етапу в інпуті
   const [stageDescriptionText, setStageDescriptionText] = useState(data !== undefined ? data.description : '')
   //для оновлення селекта
   const [reloadKey, setReloadKey] = useState(0)
   const navigate = useNavigate()

   //стилі для селекту
   const customStyles = {
      menuList: (provided) => ({
         ...provided,
         maxHeight: '200px',
         overflowY: 'auto',
      }),
   };



   const loadOptions = async (inputValue = '') => {
      if (role === 'ROLE_ADMIN') {
         return await AxiosInstance.get(`/work_stages_lists?name=${inputValue}`
            // , header
         ).then((response) => {
            console.log('response.data', response.data)
            const options = response.data['hydra:member']?.map((result) => ({
               label: result.name,
               value: result.id,
            })
            );
            console.log('options', options)
            return options

         });
      } else {
         // if (userData.id) {
         //    return await AxiosInstance.get(`/accounts?user.id=${userData.id}&name=${inputValue}`, header).then((response) => {
         //       return response.data.map((result) => ({
         //          label: result.name,
         //          value: result.id,
         //       }));
         //    });
         // }
         return []
      }
   }

   // функція для додавання етапу
   function addItem() {
      if (stageInputText === '' || stageDescriptionText === '') return

      const send_data = {
         name: stageInputText,
         description: stageDescriptionText
      }

      AxiosInstance.post(`/work_stages_lists`, send_data
         // , header
      ).then((response) => {
         console.log('response.data', response.data)
         // return response.data.map((result) => ({
         //    label: result.name,
         //    value: result.id,
         // }));
         toast.success('Новий етап роботи додано')
         setStageInputText('')
         setStageDescriptionText('')
         setReloadKey((prev) => prev + 1)

      }).catch(e => toast.error('Новий етап роботи не додано'));

   }

   //функція для редагування етапу
   function updateItem() {
      if (stageInputText === '' || stageDescriptionText === '') return

      const send_data = {
         name: stageInputText,
         description: stageDescriptionText
      }
      console.log('send_data', send_data)

      AxiosInstance.put(`/work_stages_lists/${dataState.id}`, send_data
         // , header
      ).then((response) => {
         console.log('response.data', response.data)
         toast.success('Етап успішно змінено')
         // setStageInputText('')
         // setStageDescriptionText('')
         setDataState(response.data)
         setReloadKey((prev) => prev + 1)

      }).catch(e => toast.error('Етап роботи не змінено'));

   }



   useEffect(() => {
      setStageInputText(dataState.name)
      setStageDescriptionText(dataState.description)

   }, [dataState])


   // console.log('loadOptions', loadOptions)
   console.log('dataState', dataState)

   if (role !== 'ROLE_ADMIN') { return }

   return (
      <>
         {/* Частина з реакт селектом этапів */}
         <div>
            <h2>Редагувати етап</h2>
            {/* <AsyncSelect
               key={reloadKey}
               cacheOptions
               loadOptions={loadOptions}
               defaultOptions
               // value={partnerFilterSearch}
               // onChange={handleChangePartner}
               className="flex-grow-1"
               placeholder="Этапи робіт"
               styles={customStyles}
            /> */}
         </div>
         {/* Частина для додавання нового етапу до довідника з інпутом для назви */}
         <div>
            <CFormLabel className="mt-3" htmlFor="exampleFormControlInput1">Введіть назву етапу</CFormLabel>
            <CFormInput
               type="text"
               id="exampleFormControlInput1"
               // defaultValue="Введіть назву нового етапу"
               value={stageInputText}
               onChange={(e) => setStageInputText(e.target.value)}
               placeholder="Введіть назву етапу"
               autoComplete="off"
            />
         </div>
         <div>
            <CFormLabel className="mt-3" htmlFor="exampleFormControlInput2">Введіть опис етапу</CFormLabel>
            <CFormTextarea
               type="text"
               id="exampleFormControlInput2"
               // defaultValue="Введіть опис нового етапу"
               value={stageDescriptionText}
               onChange={(e) => setStageDescriptionText(e.target.value)}
               placeholder="Введіть опис етапу"
               autoComplete="off"
            />
            <CButton
               className="mt-3"
               onClick={updateItem}
               disabled={stageInputText === dataState.name && stageDescriptionText === dataState.description}
            >Зберегти</CButton>
         </div>
      </>
   )
}